export const IconDjinni20: {
  name: 'icon_djinni_20-3e976231d931'
} = {
  name: 'icon_djinni_20-3e976231d931'
}
